import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent implements OnInit {

  pageTitle: string = '';
  pageDescription: string = '';

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    this.getPageTitleAndDescription(this.route.root);
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      this.getPageTitleAndDescription(this.route.root);
    });
  }

  getPageTitleAndDescription(route: ActivatedRoute) {
     // Check if the current route has data
     if (route.snapshot.data['pageTitle']) {
      this.pageTitle = route.snapshot.data['pageTitle'];
      this.pageDescription = route.snapshot.data['pageDescription'];
    }

    // Recursively check the child routes
    const children: ActivatedRoute[] = route.children;
    if (children.length > 0) {
      children.forEach(child => this.getPageTitleAndDescription(child));
    }
  }

}
